import { gql } from '@apollo/client';

export default gql`
  query priceBookProducts($partnerLocationId: ID!, $productIds: [ID!]) {
    priceBookProducts(
      partnerLocationId: $partnerLocationId
      productIds: $productIds
    ) {
      id
      price
      wholesalePrice
      showInStore
      overPrice
      overrideWholesalePrice
      productId
      product {
        id
        name
        arches
        price
        wholesalePrice
        isRetainer
        isEot
        description
        defaultSubscriptionRetainer
        featuredImage
        productType
        productFeatures {
          id
          text
        }
      }
    }
  }
`;
